/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResDto } from '../../models/auth-res-dto';
import { CredentialsDto } from '../../models/credentials-dto';

export interface AuthControllerLogin$Params {
  body: CredentialsDto;
}

export function authControllerLogin(
  http: HttpClient,
  rootUrl: string,
  params: AuthControllerLogin$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AuthResDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthResDto>;
      }),
    );
}

authControllerLogin.PATH = '/auth/login';
